import apiClient from "./api";

// Crée un mandataire
export const createMandataire = async (formData) => {
    try {
      // Log des données dans FormData avant l'envoi
      // console.log("Données envoyées via FormData :");
      // for (let [key, value] of formData.entries()) {
      //   console.log(`${key}:`, value);
      // }
  
      const response = await apiClient.post(`/api/Mandataire`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      // Log de la réponse de l'API
      // console.log("Réponse de l'API :", response.data);
  
      return response.data;
    } catch (error) {
      // console.error("Erreur lors de la création du mandataire :", error);
      if (error.response) {
        // console.error("Données de réponse :", error.response.data);
        // console.error("Statut :", error.response.status);
      }
      throw error;
    }
  };

// Récupère tous les mandataires pour un compte spécifique
export const getMandatairesByAccount = async (accountId, domainId) => {
  try {
    const response = await apiClient.get(
      `/api/Mandataire/account/${accountId}/${domainId}`
    );
    return response.data;
  } catch (error) {
    // console.error("Erreur lors de la récupération des mandataires par compte :", error);
    throw new Error("Erreur lors de la récupération des mandataires par compte :", error);
  }
};

// Récupère tous les mandataires pour un domaine
export const getAllMandatairesByDomain = async (domainId) => {
  try {
    const response = await apiClient.get(`/api/Mandataire/all/${domainId}`);
    return response.data;
  } catch (error) {
    // console.error("Erreur lors de la récupération de tous les mandataires :", error);
    throw new Error("Erreur lors de la récupération de tous les mandataires :", error);
  }
};

// Récupère un mandataire par son ID
export const getMandataireById = async (id) => {
  try {
    const response = await apiClient.get(`/api/Mandataire/${id}`);
    return response.data;
  } catch (error) {
    // console.error("Erreur lors de la récupération du mandataire :", error);
    throw new Error("Erreur lors de la récupération du mandataire :", error);
  }
};

// Met à jour un mandataire existant
export const updateMandataire = async (id, updatedData) => {
    try {
      // console.log("Données envoyées pour la mise à jour :", updatedData); // Log pour débogage
      const response = await apiClient.put(`/api/Mandataire/${id}`, updatedData, {
        headers: {
          "Content-Type": "application/json", // Assurez-vous que les données sont envoyées en JSON
        },
      });
      return response.data;
    } catch (error) {
      // console.error("Erreur lors de la mise à jour du mandataire :", error);
      throw new Error("Erreur lors de la mise à jour du mandataire :", error);;
    }
  };

// Supprime un mandataire
export const deleteMandataire = async (id) => {
  try {
    const response = await apiClient.delete(`/api/Mandataire/${id}`);
    return response.data;
  } catch (error) {
    // console.error("Erreur lors de la suppression du mandataire :", error);
    throw new Error ("Erreur lors de la suppression du mandataire :", error);
  }
};